// Add your JS customizations here
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import scrollToId from "./modules/scroll-to-id";
import bindSwiperVideoFullscreen from "./modules/swiper-video-fullscreen";
import videoPlayback from "./modules/video-playback";

document.addEventListener("DOMContentLoaded", () => {
	const hamburger = document.querySelector(".hamburger");
	if (hamburger) {
		hamburger.addEventListener("click", (e) => {
			e.currentTarget.classList.toggle("is-active");
			document.body.classList.toggle("menu-open");
		});
	}

	scrollToId.init();
	videoPlayback.init();

	if (document.querySelector(".gallery-swiper")) {
		const gallerySwiper = new Swiper(
			document.querySelector(".gallery-swiper"),
			{
				modules: [Navigation],
				loop: true,
				slidesPerView: 1,
				breakpoints: {
					1024: {
						slidesPerView: "auto",
					},
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
		);
	}

	if (document.querySelector("#successStoriesSlider")) {
		const successStoriesSlider = document.querySelector("#successStoriesSlider");
		const successStoriesSwiper = new Swiper(successStoriesSlider, {
			modules: [Navigation],
			loop: !window.matchMedia("(max-width: 991px)").matches,
			slidesPerView: 1,
			spaceBetween: 20,
			preventClicks: false,
			preventClicksPropagation: false,
			touchStartPreventDefault: false,
			noSwipingSelector: "video, .field_media_video_file",
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});

		bindSwiperVideoFullscreen(successStoriesSwiper);
		videoPlayback.bindSwiper(successStoriesSwiper);
	}

	const benefitsSlider = (() => {
		const mql = window.matchMedia("(max-width: 991px)");
		let swiper;

		const enableSlider = () => {
			if (mql.matches) {
				swiper = new Swiper("#benefitsSlider", {
					modules: [Pagination],
					slidesPerView: 1,
					spaceBetween: 20,
					breakpoints: {
						768: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
					},
					speed: 1000,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});

				videoPlayback.bindSwiper(swiper);
			} else {
				if (swiper) {
					swiper.destroy();
				}
			}
		};

		const init = () => {
			enableSlider();
			mql.addEventListener("change", enableSlider);
		};

		return {
			init,
		};
	})();

	const meetingsSlider = (() => {
		const mql = window.matchMedia("(max-width: 991px)");
		let swiper;

		const enableSlider = () => {
			if (mql.matches) {
				swiper = new Swiper("#meetingsSlider", {
					modules: [Pagination],
					slidesPerView: 1,
					spaceBetween: 20,
					breakpoints: {
						768: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
					},
					speed: 1000,
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});

				videoPlayback.bindSwiper(swiper);
			} else {
				if (swiper) {
					swiper.destroy();
				}
			}
		};

		const init = () => {
			enableSlider();
			mql.addEventListener("change", enableSlider);
		};

		return {
			init,
		};
	})();

	benefitsSlider.init();
	meetingsSlider.init();
});
